import { atomFamily } from "recoil";

export const selectedOptionForDateFilterAtom = atomFamily<string | undefined, number>({
  key: "selectedOptionForDateFilterAtom",
  default: "",
});
